module.exports = __webpack_public_path__ + "static/media/armadillo-header-logo.7bb22dce.svg";